import _ from 'lodash';
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { AppConstant } from '../../../../../../Assests/AppConstant';
import { sagaActions } from '../../../../../../../sagas/sagaActions';
import { getTruckSelector } from '../../../../../../../redux/reducers/reducerSlices/getTruckReducer';

import './TruckListTitle.css';
import { getUserSelector } from '../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { getDefaultDashboardSelector } from '../../../../../../../redux/reducers/reducerSlices/DefaultDashboardReducer';

const TruckListTitle = (props) => {

    const dispatch = useDispatch();
    const {themeSelected} = props;
    const { tableHeader } = AppConstant.poManagement;
    const getTruck = useSelector(getTruckSelector);
    const { truckList, arrangeOrder, arrangeKey } = getTruck;
    const userPermission = useSelector(getUserSelector);
    const { selectedWarehouse } = userPermission;
    const defaultDashboard = useSelector(getDefaultDashboardSelector);
    const { isWorkDay } = defaultDashboard;
    // const [order, setOrder] = useState(AppConstant.commonStrings.arrange);
    const [checkAll, setCheckAll] = useState(false);

    const { useCarrier } = props;
    
    //Commented for ALDI-1.0
    // const titleClickHandler = e => {
    //     const getID = e.target.id ? e.target.id : e.target.closest('th').id
    //     let arrange = {
    //         key: getID
    //     }
    //     if (getID !== 'checkAll') {
    //         if (arrangeOrder === 'asc') {
    //             arrange.order = 'desc'
    //         } else {
    //             arrange.order = 'asc'
    //         }
            
    //         const newdata = _.orderBy(truckList, [arrange.key], [arrange.order]);
    //         // const data = {
    //         //     truckList: newdata,
    //         //     getListLoading

    //         // }
    //         dispatch({ type: sagaActions.SORT_TRUCK_LIST, payload: arrange })
    //         dispatch({ type: sagaActions.UPDATE_TRUCK, payload: newdata })
    //     }
    // }

    const titleClickHandler = (e) => {
        const getID = e.target.id || e.target.closest('th').id;
        let arrange = { key: getID };
    
        if (getID !== 'checkAll') {
            arrange.order = arrangeOrder === 'asc' ? 'desc' : 'asc';
    
            const newdata = _.orderBy(
                truckList,
                [(item) => {
                    const val = item[getID];
    
                    // Numeric string
                    if (val != null && !isNaN(val) && val !== '') {
                        return Number(val);
                    }
    
                    // Date string
                    if (typeof val === 'string' && !isNaN(Date.parse(val))) {
                        return new Date(val);
                    }
    
                    // Locale-aware string compare
                    return typeof val === 'string' ? val.toLocaleLowerCase() : val;
                }],
                [arrange.order]
            );
    
            dispatch({ type: sagaActions.SORT_TRUCK_LIST, payload: arrange });
            dispatch({ type: sagaActions.UPDATE_TRUCK, payload: newdata });
        }
    }

    const checkAllHandler = (e) => {
        e.stopPropagation();
        setCheckAll(!checkAll);
        let updatePOList = []
        if (checkAll) {
            updatePOList = truckList.map(el => {
                let newEl = { ...el };
                newEl.checked = false;
                return newEl
            })
        } else {
            updatePOList = truckList.map(el => {
                let newEl = { ...el };
                newEl.checked = true;
                return newEl;
            })
            }
        // const data = {
        //         truckList: updatePOList,
        //         getListLoading

        //     }
            dispatch({ type: sagaActions.UPDATE_TRUCK, payload: updatePOList })
        }

        return (
            <thead>
                <tr className={`text-center align-middle ${themeSelected} truck-list-title`}>
                    {/* Asked by Rajesh to comment */}
                    {/* <th className={`col-md-1 px-0 table-title-checkBox ${themeSelected}`} id="checkAll"> */}
                        {/* This was commented */}
                        {/* <div className="input-group mx-4"> */}
                        {/* <input type="checkbox" onChange={checkAllHandler} value={checkAll} data-testid={AppConstant.dataTestId.tableCheckAll} /> */}
                        {/* This was commented */}
                        {/* <div className='table-title-checkBox'>
                            <input type="checkbox" />
                        </div> */}
                        {/* </div> */}
                    {/* </th> */}
                    {/* <th scope="col" className={`col-md-1 px-0 ${themeSelected}`}></th> */}
                    {selectedWarehouse?.operationType === 'WORKDAY'  && isWorkDay ? <th scope="col" className={`col-md-2 px-0 ${themeSelected}`} id='truckSequence' onClick={titleClickHandler}>
                        <span>{tableHeader.seqNumber}</span>
                        <i className="fa fa-fw fa-sort"></i>
                    </th>: ''}
                    <th scope="col" className={`col-md-1 px-0 ${themeSelected}`} id='po' onClick={titleClickHandler}>
                        <span>{tableHeader.po}</span>
                        <i className="fa fa-fw fa-sort"></i>
                    </th>
                    <th scope="col" className={`col-md-2 px-0 ${themeSelected}`} id='appointment_time' onClick={titleClickHandler}>
                        <span>{tableHeader.appointment_time}</span>
                        <i className="fa fa-fw fa-sort"></i>
                    </th>
                    {/* <th scope="col" className={`col-md-2 px-0 ${themeSelected}`} id='carrier'>
                        <span>{tableHeader.carrier}</span>
                        <i className="fa fa-fw fa-sort"></i>
                    </th> */}

                    <th scope="col" className={`col-md-2 px-0 ${themeSelected}`} id={useCarrier}>
                        <div className="d-flex align-items-center gap-2">
                            <select
                                className="form-select form-select-sm shadow-none focus:ring-0 focus:outline-none"
                                value={useCarrier} 
                                onClick={(e) => e.stopPropagation()} // Prevent sort trigger
                                onChange={(e) => {
                                    dispatch({ type: sagaActions.UPDATE_TRUCK_COLUMN_TITLE_USE_CARRIER, payload: e.target.value })
                                }}
                            >
                                <option value="carrier">Carrier</option>
                                <option value="vendor">Vendor</option>
                            </select>
                            <i className="fa fa-fw fa-sort text-muted" onClick={titleClickHandler}></i> {/* Optional visual */}
                        </div>
                    </th>



                    <th scope="col" className={`col-md-2 px-0 ${themeSelected}`} id='check_in_time' onClick={titleClickHandler}>
                        <span>{tableHeader.check_in_time}</span>
                        <i className="fa fa-fw fa-sort"></i>
                    </th>
                    <th scope="col" className={`col-md-2 px-0 ${themeSelected}`} id='dock' onClick={titleClickHandler}>
                        <span>{tableHeader.dock}</span>
                        <i className="fa fa-fw fa-sort"></i>
                    </th>
                    <th scope="col" className={`col-md-1 px-0 ${themeSelected}`} id='door' onClick={titleClickHandler}>
                        <span>{tableHeader.door}</span>
                        <i className="fa fa-fw fa-sort"></i>
                    </th>
                    <th scope="col" className={`col-md-1 px-0 ${themeSelected}`} id='truck_load_status' onClick={titleClickHandler}>
                        <span>{tableHeader.status}</span>
                        <i className="fa fa-fw fa-sort"></i>
                    </th>
                </tr>
            </thead>
        )
    }

    export default TruckListTitle;